import { useState } from "react";
import { FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export const PanelTester = () => {
  const [msg, setMsg] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!msg.trim()) return;
    setBusy(true);
    try { setRes((await api.post("/panel-test", { message: msg })).data); }
    catch (e) { setRes({ replies: [], raw: e.response?.data?.detail || "Erro ao chamar o painel" }); }
    setBusy(false);
  };

  return (
    <section className="panel-card space-y-3" data-testid="panel-tester">
      <div className="flex items-center gap-2"><FlaskConical className="w-4 h-4 text-[#A78BFA]" /><p className="text-sm font-medium">Testar painel IPTV</p></div>
      <p className="text-xs text-[#6B7280]">Envie uma palavra direto ao painel (sem IA) para descobrir qual comando gera o teste. Salve a URL do painel antes.</p>
      <div className="flex gap-2">
        <Input value={msg} onChange={(e) => setMsg(e.target.value)} onKeyDown={(e) => e.key === "Enter" && run()} placeholder="ex.: teste" className="input-dark font-mono" data-testid="panel-test-input" />
        <Button onClick={run} disabled={busy} className="btn-primary h-10" data-testid="panel-test-button">{busy ? "..." : "Enviar"}</Button>
      </div>
      {res && (
        <div className="space-y-2" data-testid="panel-test-result">
          {res.replies.length
            ? res.replies.map((r, i) => <p key={i} className="text-sm whitespace-pre-wrap border-l-2 border-[#8B5CF6] pl-3">{r}</p>)
            : <p className="text-sm text-amber-300">O painel não respondeu nada para essa palavra.</p>}
          <code className="block text-[11px] text-[#6B7280] break-all">{res.raw}</code>
        </div>
      )}
    </section>
  );
};
